<template>
   <main>
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          {{ termsTitle }}
        </h1>
        <a class="h1_div">
          <img src="images/basic/icon/close-b.svg" alt="" onclick="history.back()">
        </a>
      </div>
      <div class="div_padding"></div>

      <div class="menus">
        <p class="list" v-html="termsNttCn">
        </p>
      </div>
      <div class="div_padding"></div>
    </div>
  </main>
</template>

<script>
import { fetchTermsDetail } from '@/api/notice'
export default {
  data() {
    return {
      termsNttCn: '',
      termsTitle: ''
    }
  },
  created() {
    fetchTermsDetail({
      nttId: this.$route.query.nttId
    })
    .then(({ data }) => {
      this.termsTitle = data.result.nttSj
      this.termsNttCn = data.result.nttCn
    })
  },
  methods: {
    goToTermsOfUse(nttId) {
      this.$router.push({
        path: '/termsDetail', query: {
          nttId
        }
      })
    }
  },
  
}
</script>


<style scoped>

.menus {
  width: 100%;
  padding: 0 30px;
}
.menus .list {
  width: 100%;
}
</style>